import { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'

import { NestedListContext } from './NestedListContext'
import NestedListItem from './NestedListItem'
import equals from '../utils/nestedListUtils/equals'
import indexTree from '../utils/nestedListUtils/indexTree'
import unIndexTree from '../utils/nestedListUtils/unIndexTree'
import unwrap from '../utils/nestedListUtils/unwrap'
import wrap from '../utils/nestedListUtils/wrap'

export { NestedListItem }

export default class NestedList extends Component {
  static propTypes = {
    data: ImmutablePropTypes.list.isRequired,
    onDataChange: PropTypes.func,
    validate: PropTypes.func,
    isReadOnly: PropTypes.bool,
    children: PropTypes.func.isRequired,
  }

  constructor(props) {
    super()

    this.state = {
      data: indexTree(wrap(props.data)),
      draggedIds: undefined,
      validationError: undefined,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: indexTree(wrap(nextProps.data)),
        draggedIds: undefined,
      })
    }
  }

  reset() {
    this.setState({
      data: indexTree(wrap(this.props.data)),
      draggedIds: undefined,
    })
  }

  preview(newData, draggedIds, validationError) {
    this.setState({ data: newData, draggedIds, validationError })
  }

  persist(newData) {
    const data = unwrap(unIndexTree(newData || this.state.data))
    this.reset()

    if (!equals(data, this.props.data)) {
      this.props.onDataChange(data)
    }
  }

  render() {
    return (
      <NestedListContext.Provider value={this}>
        {this.props.children(unwrap(this.state.data), this.state.draggedIds, this.state.validationError)}
      </NestedListContext.Provider>
    )
  }
}
